import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component } from 'intact-vue-next';
import { bind } from '../utils';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { useConfigContext } from '../config';
export var typeDefs = {
  type: ['default', 'primary', 'danger', 'success', 'warning'],
  closable: Boolean,
  closed: Boolean,
  disabled: Boolean,
  size: sizes,
  border: ['solid', 'dashed', 'none']
};
var defaults = function defaults() {
  return {
    type: 'default',
    size: 'default',
    border: 'none'
  };
};
var events = {
  close: true
};
export var Tag = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tag, _Component);
  function Tag() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Tag.prototype;
  _proto.onClose = function onClose(e) {
    e.stopPropagation();
    if (this.get('disabled')) return;
    this.trigger('close', e);
    if (!e.defaultPrevented) {
      this.set('closed', true);
    }
  };
  return Tag;
}(Component);
Tag.template = template;
Tag.typeDefs = typeDefs;
Tag.defaults = defaults;
Tag.events = events;
__decorate([bind], Tag.prototype, "onClose", null);